import * as apiFactory from "./ApiFactory";

export async function get(clientName: string, brand: string, caseReference: string): Promise<CaseFileSecurity> {
  const client = await apiFactory.WithBearer();
  return await client.get(`api/CaseSecurity/${clientName}/${brand}/${encodeURIComponent(caseReference)}`);
}

export async function addTag(
  clientName: string,
  brand: string,
  caseReference: string,
  entry: string,
  concurrency: string,
): Promise<void> {
  const client = await apiFactory.WithBearer();
  await client.post(`api/CaseSecurity/tag/${clientName}/${brand}/${encodeURIComponent(caseReference)}`, {
    tag: entry,
    concurrency,
  });
}

export async function excludeTag(
  clientName: string,
  brand: string,
  caseReference: string,
  entry: string,
  concurrency: string,
): Promise<void> {
  const client = await apiFactory.WithBearer();
  await client.post(`api/CaseSecurity/tag/${clientName}/${brand}/${encodeURIComponent(caseReference)}/delete`, {
    tag: entry,
    concurrency,
  });
}

export async function addNominatedUser(
  clientName: string,
  brand: string,
  caseReference: string,
  entry: string,
  concurrency: string,
): Promise<void> {
  const client = await apiFactory.WithBearer();
  await client.post(`api/CaseSecurity/nominatedUser/${clientName}/${brand}/${encodeURIComponent(caseReference)}`, {
    identityProviderId: entry,
    concurrency,
  });
}

export async function excludeNominatedUser(
  clientName: string,
  brand: string,
  caseReference: string,
  entry: string,
  concurrency: string,
): Promise<void> {
  const client = await apiFactory.WithBearer();
  await client.post(
    `api/CaseSecurity/nominatedUser/${clientName}/${brand}/${encodeURIComponent(caseReference)}/delete`,
    { identityProviderId: entry, concurrency },
  );
}

export async function restoreContributor(
  clientName: string,
  brand: string,
  caseReference: string,
  entry: string,
  concurrency: string,
): Promise<void> {
  const client = await apiFactory.WithBearer();
  await client.post(`api/CaseSecurity/contributor/${clientName}/${brand}/${encodeURIComponent(caseReference)}`, {
    identityProviderId: entry,
    concurrency,
  });
}

export async function excludeContributor(
  clientName: string,
  brand: string,
  caseReference: string,
  entry: string,
  concurrency: string,
): Promise<void> {
  const client = await apiFactory.WithBearer();
  await client.post(
    `api/CaseSecurity/contributor/${clientName}/${brand}/${encodeURIComponent(caseReference)}/exclude`,
    { identityProviderId: entry, concurrency },
  );
}

export interface CaseFileSecurity {
  tags: CaseTag[];
  contributors: CaseUser[];
  nominatedUsers: CaseUser[] | null;
  /*  */
  excludedTags: CaseTag[];
  excludedContributors: CaseUser[] | null;
  excludedNominatedUsers: CaseUser[] | null;
  /*  */
  additionalTags: CaseTag[];
  additionalNominatedUsers: CaseUser[] | null;
  /*  */
  recordTags: CaseTag[];
  recordContributors: CaseUser[] | null;
  recordNominatedUsers: CaseUser[] | null;
  /*  */
  concurrency: string;
}

export interface CaseTag {
  name: string;
  appliedBy?: string;
  appliedOn?: string /* Parsable to date */;
}

export type CaseUser = string;
